import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {constance} from "../../../common/constance/constance";
import {MenuItem, MenuList, Paper, Tooltip} from "@mui/material";
import {Club} from "../../../interface/club.interface";
import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import {MenuInterface} from "../../../interface/menu.interface";
import {common} from "../../../common/common";
import {styles} from "../../../common/style";
import {EmotionInterface} from "../../../interface/emotion.interface";
import {User} from "../../../interface/user.interface";
import {PostInterface} from "../../../interface/post.interface";
import Stack from "@mui/material/Stack";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EmotionDialog from "./EmotionDialog";
import Button from "@mui/material/Button";
import PeopleIcon from '@mui/icons-material/People';
import Groups2TwoToneIcon from '@mui/icons-material/Groups2TwoTone';
export default function EmotionBox(props: { post: any, emotionDetailList: EmotionInterface[], state: any, setState: any }) {

    console.log('EmotionBox');

    const [state, setState] = useState({
        openEmotionList: false
    })

    let emotionDetailValues = JSON.parse(JSON.stringify(constance.emotionList));

    for (let emotion of props.emotionDetailList) {
        let found = emotionDetailValues.find((e: { id: string, value: string }) => e.id == emotion.id);
        found.users.push(emotion.user);
    }


    function updateEmotion(post: PostInterface, emotion: { id: string; value: string }) {
        axios.post(constance.api.updateEmotion, {
            params: {
                postId: post._id,
                id: emotion.id
            }
        }).then(value => {
            console.log(value);
            props.setState({
                ...props.state,
                emotionDetailList: value.data.emotionDetailList
            })
        })
    }

    function showEmotionDetail() {
        setState({
            ...state,
            openEmotionList: !state.openEmotionList
        })
    }

    return (
        <Stack sx={{
            width: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2,
        }}>

            <Box sx={{
                // width: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                {
                    emotionDetailValues.map((emotion: { id: string, value: string, users: User[] }, index: number) => {
                        return (
                            <Stack key={index}
                                   sx={{
                                       display: 'flex', justifyContent: 'center',
                                       alignItems: 'center', width: 55, height: 65
                                   }}>
                                <Typography onClick={() => updateEmotion(props.post, emotion)}
                                            sx={{
                                                cursor: 'pointer',
                                                fontSize: 35,
                                                transition: 'all ease-out 0.1s',
                                                ': hover': {fontSize: 45}
                                            }}>
                                    {emotion.value}
                                </Typography>

                                <Typography align={"center"}>
                                    {emotion.users.length}
                                </Typography>
                            </Stack>
                        )
                    })
                }
            </Box>

            <Tooltip title={'자세히'}>
                <Button variant={"outlined"}
                        color={"neutral"}
                        onClick={showEmotionDetail} size={"small"} sx={{mt: 2,}}>
                    <Groups2TwoToneIcon fontSize={"large"} color={"inherit"}/>
                </Button>
            </Tooltip>


            <EmotionDialog state={state} setState={setState} emotionDetailList={props.emotionDetailList}/>

        </Stack>
    )
}